import angular from 'angular';
import config from 'app/config';
import template from './cta.tpl.html';
import './cta.scss';

class CTAController {

  constructor($rootScope, $window, $compile, $scope, $timeout, $sce, appService, pageService, userService) {
    this.$rootScope = $rootScope;
    this.page = $rootScope.page;
    this.$window = $window;
    this.$compile = $compile;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$sce = $sce;
    this.$appService = appService;
    this.$pageService = pageService;
    this.$userService = userService;
    this.modalInstance = '';
    this.progress = 0;
    this.modalinc = '';
    this.ms = '';
  }

  $onInit() {
    this.button = this.page.options.button;
    this.text = this.btntext || this.button.text;
    this.link = this.action || this.button.action;
    this.target = this.target || this.button.target;
    this.btnclass = this.btnclass || 'btn btn-danger btn-lg';
    this.align = this.btnalign || 'text-center';
    this.arrow = this.btnarrow || true;
    this.form = this.page.options.hsform;
    this.redirectUrl = '';
    this.initOptin();
    this.getHSUser();

    this.$rootScope.$on("updateLink", (evt, newlink) => {
      if(newlink) {
        this.link = newlink;
      }
    })
  }

  initOptin() {
    if(!document.getElementById('modal')) {
      this.modaldiv = document.createElement('div');
      this.modaldiv.setAttribute('id', "modal");
      this.modaldiv.setAttribute('class', "modal");
      this.modaldiv.setAttribute('tabindex', "-1");
      document.body.appendChild(this.modaldiv);
      // this.$compile(this.modal)(this.$scope);
    }
  }

  optin($e) {
    this.progress = 0;
    this.modal = document.getElementById('modal');
    this.modal.innerHTML = '<div class="modal-dialog"> <div class="modal-content"> <button type="button" class="btn p-0 btn-close" data-bs-dismiss="modal" aria-label="Close">x</button><div ng-include="$ctrl.modalinc"></div></div></div>';
    let modalbaspath = config.production ? 'views/' : 'mlr/'
    if([732,762,836,1014,1063,1147,1381,1479].indexOf(this.page.id) > -1) {
      this.modalinc = this.$sce.trustAsResourceUrl(`${modalbaspath}modals/modal.${this.page.id}.html`);
    } else {
      this.modalinc = this.$sce.trustAsResourceUrl(`${modalbaspath}modals/modal.tpl.html`);
    }

    import(
      /* webpackChunkName: "modal" */
      './../modal/modal'
    ).then(modalService => {
      this.ms = new modalService.default();
      this.ms.bsToggle = this.modal;
      this.ms.setSpinner($e);
      this.ms.initModal();
      this.$compile(this.modal)(this.$scope);
      this.$rootScope.$apply();
    });
  }

  openModal() {
    this.modal = document.getElementById(this.target);
    import(
      /* webpackChunkName: "modal" */
      './../modal/modal'
    ).then(modalService => {
      this.ms = new modalService.default();
      this.ms.setModal(this.target);
      this.ms.setClearContent(false);
      this.ms.bsToggle = this.modal;
      this.ms.initModal();
      this.$compile(this.modal)(this.$scope);
      this.$rootScope.$apply();
    });
  }

  onClick() {
    if(this.$userService.email) {
      let linktext = this.text;
      this.text = 'Please wait...saving your request!';
      let event = {email:this.$userService.email, eventName:this.page.options.hsform.event.id};
      this.$pageService.post('hs/event', event).then(result => {
        if(result.data.status == 'ok') {
          let alink=document.createElement('a');
          alink.target='_blank';
          alink.href= this.$appService.cta(this.page.options.button.sslink);
          alink.click();
        }
        this.text = linktext;
      });
    } else {
      this.$window.open(this.$appService.cta(this.page.options.button.sslink), '_blank');
    }
  }

  scrollTo(target) {
    const scrollBtn = document.querySelector(".btn");
    var anchor = document.querySelector(target);
    anchor.scrollIntoView();
  }

  setPwyc(pwyc) {
    this.form.redirect = this.form.redirect+'?'+this.$appService.appendParam('pwyc', pwyc);
    this.$window.open(this.form.redirect, '_blank')
  }

  validateFormCoupon(ngform) {
    if (ngform.$valid) {
      this.$pageService.post('page/validate/tygl/coupon', this.user).then((result) => {
        if(result.data.status == 'ok') {
          this.error = false;
          this.progress = 50;
          this.page.options.hsform.properties = {"email": this.user.femail};
        } else {
          this.error = true;
        }
      })
    } else {
      ngform.$submitted = true;
    }
  }

  validateSOSCode(ngform) {
    if (ngform.$valid) {
      this.$pageService.getRow('page/verify/'+this.user.coupon).then((result) => {
        if(result.data.status == 'ok') {
          this.error = false;
          this.progress = 50;
        } else {
          this.error = true;
        }
      })
    } else {
      ngform.$submitted = true;
    }
  }

  getHSUser() {
    if(this.$userService.email && (this.page.id == 827 || this.page.id == 828)) {
      this.$userService.getUser(this.$userService.email+"?property=tygl_aug_2022_join_date").then((result) => {
        var hasValue = this.$userService.checkProperty(result.data.data.properties, 'tygl_aug_2022_join_date');
        if(hasValue != '') {
          this.link = this.button.bookcall;
        }
      })
    }
  }

  setActionCookie(progress, cookie, redirect) {
    this.progress = progress;
    this.delayRedirect(redirect.link, redirect.delay);
    // if(cookie) {
    //   this.$userService.setCookie(cookie.name,cookie.value,cookie.expire);
    // }
  }

  delayRedirect(redirect, delay, cookie) {
    this.mytimeout = 0;
    this.counter = delay;
    this.onTimeout = (() => {
      if (this.counter > 0) {
        this.counter--;
        this.mytimeout = this.$timeout(this.onTimeout, 1000);
      } else if (this.counter == 0) {
        if(cookie) {
          this.$userService.setCookie(cookie.name,cookie.value,cookie.expire);
        }
        if(this.modalInstance) {
          this.modalInstance.hide();
        }
        this.$window.open(redirect, "_blank");
      }
    });
    this.mytimeout = this.$timeout(this.onTimeout, 1000);
  }

  hideModal() {
   let modalinst = this.ms.getInstance();
   modalinst.hideModal();
  }


}

CTAController.$inject = ["$rootScope", "$window", "$compile", "$scope", "$timeout", "$sce", "appService", "pageService", "userService"];

class CTAComponent {
  constructor() {
    this.bindings = {
      btntext: '@?',
      action: '@?',
      target: '@?',
      btnclass: '@?',
      btnarrow: '@?',
      btnalign: '@?'
    };
    this.template = template;
    this.controller = CTAController;
  }
}


export default angular
.module('mlrcta.component', [])
.component('mlrcta', new CTAComponent())
.name;
